import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-light-svg-icons/faSparkles';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelFoot, PanelHead } from '../../../music24/components/primitives/Panel';
import { API_DOCS_URL } from '../apiAccess/apiDocsUrl';
import { AiConnectorUrl } from './AiConnectorUrl';
import { AiSetupGuides } from './AiSetupGuides';
import { aiAssistantsMessages as messages } from './aiAssistantsMessages';
import { MCP_URL } from './mcpUrl';
import { withBrandWord } from '../../../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the AI assistants tab; each part uses its own slice of it */
import styles from './aiAssistants.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The first panel of Settings → AI assistants (design: ai-assistants a1): what the user gets, the
 * connector URL, three setup blocks, the promise and the link to the docs. It reads no data, so it
 * does not wait for the list under it.
 */
const AiAssistantsConnectComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <Panel as="section" className={styles.hero}>
      <PanelHead
        titleAs="h2"
        lead={
          <span className={styles.heroIcon} aria-hidden="true">
            <FontAwesomeIcon icon={faSparkles} />
          </span>
        }
        title={intl.formatMessage(messages.heroTitle)}
        subtitle={intl.formatMessage(messages.heroBody)}
      />
      <PanelBody className={styles.heroBody}>
        <AiConnectorUrl url={MCP_URL} />
        <AiSetupGuides />
        <div className={styles.promise}>
          <FontAwesomeIcon icon={faShieldCheck} className={styles.promiseIcon} />
          <span>{withBrandWord(intl.formatMessage(messages.promise))}</span>
        </div>
      </PanelBody>
      <PanelFoot className={styles.docs}>
        <span>{intl.formatMessage(messages.docsLead)}</span>
        <a href={API_DOCS_URL} target="_blank" rel="noopener noreferrer">
          {intl.formatMessage(messages.docsLink)}
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} className={styles.docsIcon} />
        </a>
      </PanelFoot>
    </Panel>
  );
};

export const AiAssistantsConnect = TypedMemo(AiAssistantsConnectComponent);
